import React, { ReactNode } from 'react';
import { Header } from './Header/Header';
import { Toaster } from '@/components/ui/toaster';
import { Footer } from './Footer/Footer';
import { ErrorBoundary } from 'react-error-boundary';
import Fallback from '@/components/uiKit/Fallback';
import { Button } from '@/components/ui/button';
import { RefreshCwIcon } from 'lucide-react';
import { useFetchSites, useIsDMAdmin } from '../hooks';
import { useParams } from 'react-router-dom';
import { getSiteById } from '@/store/queries';
import { DarkModeToggle } from '@/components/uiKit/DarkModeToggle';
import { cn } from '@/lib/utils';

interface LayoutProps {
  children: ReactNode;
  className?: string;
}

export const Layout = ({ children, className }: LayoutProps) => {
  const { isDMAdmin } = useIsDMAdmin();
  const { siteId } = useParams();
  return (
    <>
      {/* @TODO: update </ErrorBoundary> and use a custom components that reffers to diff errors type w dedicated components */}
      <Header />
      <ErrorBoundary FallbackComponent={Fallback}>
        <main
          className={cn(
            'pl-0 xl:pl-sidebar xl:mt-header xl:pb-header mt-mobile-header max-h-main-mobile xl:max-h-main self-center overflow-hidden xl:pt-3 relative h-main pb-2 dark:bg-[#0f1419]',
            className
          )}
        >
          {children}
        </main>
        <Toaster />
      </ErrorBoundary>

      <Footer />
      {false && <DarkModeToggle />}
    </>
  );
};
